<template>
  <div class="BaseHistoryFileRestore">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        class="elevation-1"
        :options.sync="options"
        :loading="loading"
        fixed-header
        hide-default-footer
        :height="windowHeight"
        :search="searchTerm"
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <span v-if="item.removed">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" color="primary"> mdi-delete-restore</v-icon>
            </template>
            Removed
          </v-tooltip>
        </span>
        <span v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" color="primary"> mdi-backup-restore</v-icon>
            </template>
            Restored
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.history_date="{ item }">
        {{ item.history_date | moment("DD.MM.YYYY HH:mm:ss") }} {{ item.history_user__username }}
      </template>
      <template v-slot:item.alive="{ item }">
        <span :class="{'changed-field': item.alive === false}">{{item.alive}}</span>
      </template>
      <template v-slot:item.title="{ item }">
        <div v-html="item.title"></div>
      </template>
    </v-data-table>
    <v-toolbar flat dense elevation="2" height="60">
      <v-btn
        :disabled="activeHistoryId === null"
        @click="onRestore"
      >
        Restore
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import {debounce} from "debounce";

export default {
  name: 'BaseHistoryFileRestore',
  props: ['storeDocItemId', 'activeHistoryId', 'windowHeight'],

  components: {},

  computed: {
    ...mapGetters('BaseHistoryFileRestore', ['getColumns']),
    ...mapFields('BaseHistoryFileRestore', ['wsUrl', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive']),
  },

  methods: {
    ...mapActions('BaseHistoryFileRestore', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchActionSelectedItem']),
    ...mapMutations('BaseHistoryFileRestore', ['updateFilters']),

    onRestore() {
      console.log('onRestore', this.activeHistoryId)
      this.selectedItemList = [{id: this.activeHistoryId}]
      this.fetchActionSelectedItem('restore')
      this.fetchItemList()
    },

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),
  },
  created() {
    // this.wsUrl = this.wsRestore
    console.log('this.wsUrl', this.wsUrl)
  },
  mounted() {
    this.updateFilters({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId})
    this.fetchItemList({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId});
  },
}
</script>

<style scoped lang="scss">
.changed-field {
  color: darkred;
}
</style>
